var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Message, Event } from 'grey-message';
import Heartbeat, { HeartbeatEvent } from 'grey-heartbeat';
/** 完成一次记数 */
var TimerEvent = /** @class */ (function (_super) {
    __extends(TimerEvent, _super);
    function TimerEvent() {
        return _super.call(this, TimerEvent.TYPE) || this;
    }
    TimerEvent.TYPE = Message.createType('HeartbeatEvent');
    return TimerEvent;
}(Event));
export { TimerEvent };
/** 计时器 */
var Timer = /** @class */ (function (_super) {
    __extends(Timer, _super);
    /** 计时器 */
    function Timer(interval, count) {
        if (count === void 0) { count = 1; }
        var _this = _super.call(this) || this;
        /** 当前已经执行的时间 */
        _this.currentInterval = 0;
        /** 当前已经执行的次数 */
        _this.currentCount = 0;
        /** 开始记时 */
        _this.start = function () {
            Heartbeat.instance.on(HeartbeatEvent.TYPE, _this.onHeartbeatHandler);
        };
        /** 停止记时 */
        _this.stop = function () {
            Heartbeat.instance.off(HeartbeatEvent.TYPE, _this.onHeartbeatHandler);
        };
        /** 复位停止下来 */
        _this.reset = function () {
            _this.stop();
            _this.currentCount = 0;
            _this.currentInterval = 0;
        };
        /** 复位并马上开始记时 */
        _this.resetAndStart = function () {
            _this.reset();
            _this.start();
        };
        /** 心跳事件 */
        _this.onHeartbeatHandler = function (e) {
            _this.currentInterval += e.interval;
            for (; _this.currentInterval >= _this.interval;) {
                _this.currentInterval -= _this.interval;
                _this.currentCount++;
                _this.send(new TimerEvent());
                /** 次数是否完成 */
                if (_this.count !== 0 && _this.currentCount >= _this.count) {
                    _this.stop();
                    break;
                }
            }
        };
        _this.interval = interval;
        _this.count = count;
        return _this;
    }
    return Timer;
}(Message));
export default Timer;



//////////////////
// WEBPACK FOOTER
// ./node_modules/grey-timer/index.js
// module id = 2396
// module chunks = 0